// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

// Check screen width and initialize animations only on desktop
function initDesktopAnimations() {
  if (window.innerWidth < 992) return;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".twelve-story",
      start: "top top",
      end: "+=6000", /* Increased from 4000 to 6000 for slower overall progression */
      scrub: 2.5, /* Increased from 1.5 to 2.5 for smoother, slower scrubbing */
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true
    },
    onReverseComplete: () => {
      const el = document.querySelector(".panel-4");
      if (el) el.classList.remove("active");
      gsap.set(el, { opacity: 0 });
    }
  });

  // Panel 1 - Initial setup
  tl.call(() => {
    document.querySelector(".panel-1")?.classList.add("active");
  })
  .to(".panel-1", { opacity: 1, duration: 0.5, ease: "power2.out" }, "<");

  /* ══════════════════════════════════════════
     PANEL 1 EXIT → PANEL 2 ENTER
  ══════════════════════════════════════════ */
  tl
    .to(".story-left", { 
      opacity: 0, 
      duration: 0.4, 
      ease: "power2.in" 
    })
    .to(".panel-1 .story-btn", { 
      opacity: 1, 
      duration: 0.3 
    }, "<")
    .to(".story-text, .signature-img", { 
      x: 100, 
      opacity: 0, 
      duration: 0.4,
      ease: "power2.in" 
    }, "<")
    .call(() => {
      document.querySelector(".panel-1")?.classList.toggle("active");
      document.querySelector(".panel-2")?.classList.toggle("active");
    })
    .to(".panel-2", { 
      opacity: 1, 
      duration: 0.5,
      ease: "power2.out" 
    }, "<")
    .to(".book-main", { 
      x: "-120%", 
      paddingTop: 0, 
      duration: 2.5, /* Changed from 0.5 to 2.5 - much slower */
      ease: "power2.inOut"
    }, "<")
    .to(".feature-heading, .feature-text", { 
      opacity: 1, 
      duration: 0.8,
      stagger: 0.15,
      ease: "power2.out"
    })
    .to(".panel-2 .story-btn", { 
      opacity: 1,
      duration: 0.4 
    })
    .fromTo(".feature-cards .feature-card", 
      { x: 100, opacity: 0 }, 
      { 
        x: 0, 
        opacity: 1, 
        stagger: 0.15,
        duration: 0.8,
        ease: "back.out(0.8)"
      }
    );

  /* ══════════════════════════════════════════
     PANEL 2 EXIT → PANEL 3 ENTER
  ══════════════════════════════════════════ */
  tl
    .to(".feature-cards .feature-card", { 
      y: "100%", 
      opacity: 0,
      stagger: 0.08,
      duration: 0.6,
      ease: "power2.in"
    })
    .to(".feature-heading, .feature-text", { 
      opacity: 0, 
      delay: 0.2,
      duration: 0.5 
    }, "<")
    .to(".panel-3", { 
      opacity: 1,
      duration: 0.8,
      ease: "power2.out"
    }, "<")
    .to(".panel-2", { 
      opacity: 0,
      duration: 0.6 
    }, "<")
    .to(".book-main", { 
      x: "120%", 
      paddingTop: 0, 
      delay: 0.2,
      duration: 2.5, /* Changed from 0.5 to 2.5 - much slower */
      ease: "power2.inOut"
    }, "<")
    .call(() => {
      document.querySelector(".panel-2")?.classList.toggle("active");
      document.querySelector(".panel-3")?.classList.toggle("active");
    })
    .to(".testimonial-heading", { 
      x: 0, 
      opacity: 1,
      duration: 0.8,
      ease: "power2.out"
    })
    .to(".testimonial-card", { 
      y: 0, 
      opacity: 1,
      stagger: 0.15,
      duration: 0.8,
      ease: "back.out(0.7)"
    }, "<")
    .to(".final-btn", { 
      scale: 1, 
      opacity: 1, 
      duration: 0.8,
      ease: "back.out(1.2)"
    }, "<");

  /* ══════════════════════════════════════════
     PANEL 3 EXIT → PANEL 4 ENTER
  ══════════════════════════════════════════ */
  tl
    .to(".testimonial-heading, .testimonial-card", { 
      x: -80, 
      opacity: 0,
      stagger: 0.08,
      duration: 0.6,
      ease: "power2.in"
    })
    .to(".final-btn", { 
      opacity: 0,
      duration: 0.5 
    }, "<")
    .to(".p3-book-col", { 
      x: "-120vw", 
      opacity: 0,
      duration: 0.8,
      ease: "power2.in"
    }, "<")
    .to(".panel-4", { 
      opacity: 1,
      duration: 0.8,
      ease: "power2.out"
    })
    .to(".panel-3", { 
      opacity: 0,
      duration: 0.6 
    }, "<")
    .call(() => {
      document.querySelector(".panel-3")?.classList.toggle("active");
      document.querySelector(".panel-4")?.classList.toggle("active");
    })
    .to(".book-main", { 
      x: "-120%", 
      paddingTop: 0, 
      duration: 2.5, /* Changed from 0.5 to 2.5 - much slower */
      ease: "power2.inOut"
    }, "<")
    .to(".p4-book-col", { 
      x: 0, 
      opacity: 1, 
      duration: 1.2,
      ease: "power2.out"
    })
    .to(".p4-right-col", { 
      x: 0, 
      opacity: 1, 
      duration: 1.2,
      ease: "power2.out"
    }, "<");

  /* ══════════════════════════════════════════
     PANEL 4 EXIT → PANEL 5 ENTER
  ══════════════════════════════════════════ */
  tl
    .to(".p4-right-col", {
      x: -80,
      opacity: 0,
      duration: 0.8,
      ease: "power2.in"
    })
    .to(".p4-book-col", {
      opacity: 0,
      duration: 0.6,
      ease: "power2.in"
    }, "<")
    .to(".panel-5", {
      opacity: 1,
      duration: 0.8,
      ease: "power2.out"
    }, "<0.2")
    .to(".panel-4", {
      opacity: 0,
      duration: 0.6,
      ease: "power2.in"
    }, "<")
    .call(() => {
      document.querySelector(".panel-4")?.classList.toggle("active");
      document.querySelector(".panel-5")?.classList.toggle("active");
      
      // Enable pointer events for panel-5 elements
      const panel5 = document.querySelector(".panel-5");
      if (panel5) {
        panel5.style.pointerEvents = "auto";
        const allChildren = panel5.querySelectorAll("*");
        allChildren.forEach(child => {
          child.style.pointerEvents = "auto";
        });
      }
    })
    .to(".book-main", {
      x: "-120%",
      scale: 1,
      opacity: 1,
      duration: 2.5, /* Changed from 0.6 to 2.5 - much slower */
      ease: "power2.out"
    }, "<")
    .to(".p5-right-col", {
      y: 0,
      opacity: 1,
      duration: 1.2,
      ease: "back.out(0.6)"
    })
    .to(".p5-cta-btn", {
      y: 0,
      opacity: 1,
      duration: 1,
      scale: 1,
      ease: "back.out(1)"
    }, "<0.3");
}

// FAQ Accordion with smooth animations
function initFaqAccordion() {
  document.querySelectorAll(".faq-question").forEach(function(btn) {
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var targetId = btn.getAttribute("data-target");
      var answer = document.getElementById(targetId);
      var isOpen = btn.classList.contains("active");

      // Close all open items in same accordion
      var accordion = btn.closest(".faq-accordion");
      if (accordion) {
        accordion.querySelectorAll(".faq-question.active").forEach(function(openBtn) {
          if (openBtn !== btn) {
            openBtn.classList.remove("active");
            openBtn.setAttribute("aria-expanded", "false");
            var openAnswer = document.getElementById(openBtn.getAttribute("data-target"));
            if (openAnswer) {
              openAnswer.style.maxHeight = "0";
              openAnswer.style.opacity = "0";
            }
          }
        });
      }

      // Toggle current item
      if (!isOpen && answer) {
        btn.classList.add("active");
        btn.setAttribute("aria-expanded", "true");
        answer.style.maxHeight = answer.scrollHeight + "px";
        answer.style.opacity = "1";
      } else if (answer) {
        btn.classList.remove("active");
        btn.setAttribute("aria-expanded", "false");
        answer.style.maxHeight = "0";
        answer.style.opacity = "0";
      }
    });
  });
}

// Initialize on load and resize
function initialize() {
  // First, disable pointer events on panel-5 initially
  const panel5 = document.querySelector(".panel-5");
  if (panel5) {
    panel5.style.pointerEvents = "none";
    const allChildren = panel5.querySelectorAll("*");
    allChildren.forEach(child => {
      child.style.pointerEvents = "none";
    });
  }
  
  // Initialize animations based on screen size
  initDesktopAnimations();
  
  // Initialize FAQ accordion
  initFaqAccordion();
}

// Handle window resize - kill and reinitialize animations
let currentScrollTrigger = null;

function handleResize() {
  // Kill existing ScrollTrigger if any
  if (currentScrollTrigger) {
    currentScrollTrigger.kill();
  }
  
  // Refresh ScrollTrigger to kill all instances
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  
  // Reset panel states
  document.querySelectorAll("[class*='panel-']").forEach(panel => {
    if (panel.classList.contains('active')) {
      panel.classList.remove('active');
    }
    gsap.set(panel, { opacity: 0 });
  });
  
  // Set initial panel-1 visible on desktop
  if (window.innerWidth >= 992) {
    gsap.set(".panel-1", { opacity: 1 });
    document.querySelector(".panel-1")?.classList.add("active");
  } else {
    gsap.set(".panel-1", { opacity: 1 });
    document.querySelectorAll("[class*='panel-']").forEach(panel => {
      if (panel.classList.contains('active')) {
        panel.classList.remove('active');
      }
    });
    document.querySelector(".panel-1")?.classList.add("active");
  }
  
  // Reinitialize animations
  initDesktopAnimations();
  
  // Refresh ScrollTrigger
  ScrollTrigger.refresh();
}

// Add resize listener with debounce
let resizeTimer;
window.addEventListener("resize", function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    handleResize();
  }, 250);
});

// Initialize on page load
window.addEventListener("load", initialize);

// Also initialize when DOM is ready
document.addEventListener("DOMContentLoaded", function() {
  // Ensure all panels have proper opacity
  if (window.innerWidth >= 992) {
    gsap.set(".panel-2, .panel-3, .panel-4, .panel-5", { opacity: 0 });
    gsap.set(".panel-1", { opacity: 1 });
  } else {
    gsap.set(".panel-1, .panel-2, .panel-3, .panel-4, .panel-5", { opacity: 1 });
  }
});
function initMobileAnimations() {
  if (window.innerWidth >= 992) return;

  gsap.utils.toArray(".story-panel").forEach((panel) => {
    gsap.from(panel, {
      opacity: 0,
      y: 50,
      duration: 0.8,
      ease: "power2.out",
      scrollTrigger: {
        trigger: panel,
        start: "top 85%",
        toggleActions: "play none none none"
      }
    });
  });
}


gsap.utils.toArray('.group-block-content').forEach((el) => {

  // 👇 footer elements skip karo
  if (el.closest('footer')) return;

  gsap.to(el, {
    opacity: 1,
    y: 0,
    duration: 1,
    scrollTrigger: {
      trigger: el,
      start: "top 80%",
    }
  });

});

function initMobileSlider(selector) {
  if (window.innerWidth >= 992) return;

  document.querySelectorAll(selector).forEach((slider) => {

    let isDown = false;
    let startX;
    let scrollLeft;

    slider.style.overflowX = "auto";
    slider.style.scrollBehavior = "smooth";

    slider.addEventListener("touchstart", (e) => {
      isDown = true;
      startX = e.touches[0].pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("touchmove", (e) => {
      if (!isDown) return;
      const x = e.touches[0].pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; // speed control
      slider.scrollLeft = scrollLeft - walk;
    });

    slider.addEventListener("touchend", () => {
      isDown = false;
    });

  });
}

// INIT
window.addEventListener("load", () => {
  initMobileSlider(".feature-cards");
  initMobileSlider(".testimonial-grid");
});